import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const ClearDayIcon: React.FC<IconProps> = props => (
  <Icon {...props} viewBox="0 0 24 24">
    <g transform="translate(2, 2)">
      <rect rx="2" fill="white" />
      <path
        d="M9.25 4V1H10.75V4H9.25ZM14.7708 6.33333L13.6458 5.25L15.8125 3.125L16.8958 4.16667L14.7708 6.33333ZM16 10.75V9.25H19V10.75H16ZM9.25 19V16H10.75V19H9.25ZM5.22917 6.29167L3.0625 4.16667L4.1875 3.125L6.29167 5.22917L5.22917 6.29167ZM15.8333 16.9375L13.7292 14.75L14.7708 13.7083L16.9375 15.7917L15.8333 16.9375ZM1 10.75V9.25H4V10.75H1ZM4.16667 16.9375L3.10417 15.8333L5.22917 13.75L5.75 14.25L6.25 14.7708L4.16667 16.9375Z"
        fill="currentColor"
      />
    </g>
  </Icon>
)
